import React from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Divider, Link, Stack } from '@mui/material';

interface Props {
  items: Array<{
    title: string;
    url?: string;
    onClick?: () => void;
  }>;
}

export const BreadcrumbsHeader: React.FC<Props> = ({ items }) => {
  return (
    <Stack flex={1} spacing={3} mb={1} mt={1}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" htmlColor="#C0C4CC" />}
        aria-label="breadcrumb"
      >
        {items?.map(({ title }, index) => (
          <Link
            underline="hover"
            key={index}
            color="inherit"
            href="#"
            fontSize={14}
            sx={{ color: index % 2 ? '#757575' : '#4B4B4B' }}
          >
            {title}
          </Link>
        ))}
      </Breadcrumbs>

      <Divider orientation="horizontal" />
    </Stack>
  );
};
